// Accès à la fonctionnalité « État des lieux » (rollout progressif).
//
// FAIL-CLOSED : par défaut PERSONNE n'y a accès. L'accès est ouvert dans trois cas :
//  1. l'e-mail est dans l'allowlist de sécurité (comptes internes) — toujours ;
//  2. le compte fait partie du PILOTE (empreintes anonymes edlPilotHashes : ~92 clients
//     les plus actifs + pilotes nommés par Charly, lancement 10/07) ;
//  3. le compte tombe dans le pourcentage de rollout actif (VITE_APP_EDL_ROLLOUT_PERCENT),
//     via un découpage DÉTERMINISTE et STABLE de son identifiant de compte.
//
// Ce garde-fou protège les 1 840 clients : la fonctionnalité reste invisible hors pilote
// tant que le pourcentage est à 0 (défaut). Élargir = empreintes pilotes ou % + rebuild.
import { config } from '@/core/config'
import { isEdlPilot } from './edlPilotHashes'

// Allowlist de sécurité : ces comptes ont TOUJOURS accès (pilotes internes), quel que soit
// le pourcentage.
const EDL_ALLOWLIST = ['charly.leggeri@limeare.com', 'axel@horiz.io', 'janani@horiz.io']

// E-mail de connexion (Keycloak), en minuscules. '' si non lisible -> non autorisé.
function getCurrentEmail() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  if (!tp) return ''

  return (tp.email || (tp.rl_profile && tp.rl_profile.username) || '').trim().toLowerCase()
}

// Identifiant STABLE du compte (Keycloak rl_profile.id, repli sub) : sert au découpage
// déterministe du rollout, un même compte reste toujours dans le même seau.
function getCurrentUserId() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  if (!tp) return ''

  return String((tp.rl_profile && tp.rl_profile.id) || tp.sub || '')
}

// Hash déterministe (djb2) -> seau 0..99. Monotone : augmenter le pourcentage n'exclut
// jamais un compte déjà inclus (les seaux < seuil restent < seuil).
function rolloutBucket(key) {
  let h = 5381
  for (let i = 0; i < key.length; i++) {
    h = (h * 33) ^ key.charCodeAt(i)
  }

  return (h >>> 0) % 100
}

export function isEdlEnabled() {
  const email = getCurrentEmail()
  if (email && EDL_ALLOWLIST.includes(email)) {
    return true
  }

  // Pilote : empreinte anonyme de l'e-mail OU du username Keycloak.
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  const username = (tp && tp.rl_profile && tp.rl_profile.username) || ''
  if (isEdlPilot(email) || isEdlPilot(username)) {
    return true
  }

  const percent = config.edl.rolloutPercent
  if (!percent) {
    return false
  }
  const uid = getCurrentUserId()
  if (!uid) {
    return false
  }

  return rolloutBucket('edl:' + uid) < percent
}
